/** CMS-editable sections only for /contact */
export const DEFAULT_CONTACT_CMS_CONFIG = {
  schemaVersion: 5,
  asideHeading: "Reach us directly",
  heroBackgroundUrl: "",
  directEmails: [
    { label: "General", email: "support@trocanet.com" },
    { label: "Sales", email: "sales@trocanet.com" },
    { label: "Supplier", email: "suppliers@trocanet.com" },
    { label: "RFQ", email: "rfq@trocanet.com" },
    { label: "Advertising", email: "ads@trocanet.com" },
    { label: "Technical", email: "tech@trocanet.com" },
  ],
  officeAddress:
    "TrocaExPro Business Hub, 4th Floor, MG Road, Bengaluru, Karnataka 560001, India",
  supportHours: "Mon – Sat, 9:00 AM – 7:00 PM IST",
};

function isPlainObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}

function mergeEmailRows(defaults, incoming) {
  if (!Array.isArray(incoming)) return defaults;
  return incoming.map((item, index) => {
    const base = defaults[index] || { label: "", email: "" };
    const row = isPlainObject(item) ? item : {};
    return {
      label: String(row.label ?? base.label ?? "").trim(),
      email: String(row.email ?? base.email ?? "").trim(),
    };
  });
}

export function parseContactCmsConfig(content) {
  if (!content || typeof content !== "string") {
    return { ...DEFAULT_CONTACT_CMS_CONFIG };
  }

  const trimmed = content.trim();
  if (!trimmed.startsWith("{")) {
    return { ...DEFAULT_CONTACT_CMS_CONFIG };
  }

  try {
    const parsed = JSON.parse(trimmed);
    if (!isPlainObject(parsed)) {
      return { ...DEFAULT_CONTACT_CMS_CONFIG };
    }

    const defaults = DEFAULT_CONTACT_CMS_CONFIG;
    return {
      ...defaults,
      asideHeading: String(parsed.asideHeading ?? defaults.asideHeading).trim(),
      heroBackgroundUrl: String(parsed.heroBackgroundUrl ?? defaults.heroBackgroundUrl).trim(),
      officeAddress: String(parsed.officeAddress ?? defaults.officeAddress).trim(),
      supportHours: String(parsed.supportHours ?? defaults.supportHours).trim(),
      directEmails: mergeEmailRows(defaults.directEmails, parsed.directEmails),
    };
  } catch {
    return { ...DEFAULT_CONTACT_CMS_CONFIG };
  }
}

/** Store only CMS-editable fields */
export function serializeContactCmsConfig(config) {
  const data = config || DEFAULT_CONTACT_CMS_CONFIG;
  return JSON.stringify(
    {
      schemaVersion: 5,
      asideHeading: data.asideHeading,
      heroBackgroundUrl: data.heroBackgroundUrl || "",
      directEmails: data.directEmails,
      officeAddress: data.officeAddress,
      supportHours: data.supportHours,
    },
    null,
    2,
  );
}

export function buildContactCmsSections(cmsPage) {
  const config = parseContactCmsConfig(cmsPage?.content);
  return {
    isCmsPublished: Boolean(cmsPage),
    asideHeading: config.asideHeading,
    heroBackgroundUrl: config.heroBackgroundUrl,
    directEmails: config.directEmails.filter((row) => row.email),
    officeAddress: config.officeAddress,
    supportHours: config.supportHours,
  };
}

export function contactConfigFromCmsRecord(record) {
  return parseContactCmsConfig(record?.content);
}

export function contactCmsPayloadFromConfig(config) {
  return {
    title: "Contact Us",
    description: "Official contact and support information for the Trocanet platform.",
    content: serializeContactCmsConfig(config),
  };
}

/** @deprecated use DEFAULT_CONTACT_CMS_CONFIG */
export const DEFAULT_CONTACT_PAGE_CONFIG = DEFAULT_CONTACT_CMS_CONFIG;

/** @deprecated use parseContactCmsConfig */
export const parseContactPageConfig = parseContactCmsConfig;

/** @deprecated use serializeContactCmsConfig */
export const serializeContactPageConfig = serializeContactCmsConfig;

/** @deprecated use buildContactCmsSections */
export function buildContactPageViewModel(cmsPage) {
  return buildContactCmsSections(cmsPage);
}

/** @deprecated */
export function buildContactHeroTitle() {
  return "Contact Us";
}
